import React from "react"
import { useSelector, useDispatch } from "react-redux"
import { RootState } from "@app/types"
import isWithinInterval from "date-fns/isWithinInterval"
import parseISO from "date-fns/parseISO"

import trumfTIcon from "@ng-mw/reol/icons/trumfT"
import vippsIcon from "@resources/icons/vipps-smiley-icon"
import rebateRounded from "@resources/icons/rebateRounded"

import Button from "@ng-mw/reol/components/Button"
import Tips from "@modules/shared/Tips"
import Container from "@modules/shared/Container"
import PersonalCampaigns from "@modules/user/PersonalCampaigns"
import { showTopBannerPopup } from "@app/store/app/appActions"

const TopBanner = () => {
    const dispatch = useDispatch<any>()
    const { infoBanner } = useSelector((state: RootState) => state.settings)
    const { isOrganization } = useSelector((state: RootState) => state.user.data.household)

    const loginLevel = useSelector((state: RootState) => state.user.loginLevel)
    const isLoggedIn = loginLevel > 0

    const banner = infoBanner?.banner
    if (!banner) return null

    const overrides = banner.visibilityOverrides
    const hiddenByAuth =
        (isLoggedIn && overrides?.hideForLoggedIn) || (!isLoggedIn && overrides?.hideForLoggedOut)

    const now = new Date(new Date().toDateString())

    const isDateWithinDates = isWithinInterval(now, {
        start: parseISO(banner.visibilityPeriod.startDate),
        end: parseISO(banner.visibilityPeriod.endDate),
    })

    const getBannerIcon = (bannerType: string) => {
        switch (bannerType) {
            case "trumf":
                return trumfTIcon
            case "vipps-icon":
                return vippsIcon
            case "discount-icon":
                return rebateRounded
            default:
                return null
        }
    }

    const iconKey = banner.content.icon ?? ""
    const icon = getBannerIcon(iconKey)

    const text = banner.content.text
        ? banner.content.text
        : "Husk at på torsdag så er det 3% bonus på hele butikken!"

    const useDialogWindow = Boolean(banner.dialogContent?.useDialogWindow)

    const hasPopupContent =
        Boolean(banner.dialogContent?.title) ||
        Boolean(banner.dialogContent?.description) ||
        Boolean(banner.dialogContent?.externalLink?.url) ||
        Boolean(banner.dialogContent?.image)

    const showPopup = useDialogWindow && hasPopupContent
    const handleShowPopup = () => dispatch(showTopBannerPopup())

    if (isDateWithinDates && !isOrganization && !hiddenByAuth) {
        return (
            <Container padding="reduced">
                <Tips
                    padding="small"
                    size={{ height: "24px", width: "24px" }}
                    illustration={icon}
                    text={!showPopup ? text : undefined}
                    illustrationLeftOffset="0"
                    hasNoPaddingOnContainer
                >
                    {showPopup ? (
                        <div
                            className="app-tip__content"
                            style={{
                                display: "flex",
                                width: "100%",
                                alignItems: "center",
                            }}
                        >
                            <p
                                className="app-tip__text"
                                style={{ margin: 0 }}
                            >
                                {text}
                            </p>
                            <Button
                                onClick={handleShowPopup}
                                text="Les mer"
                                isPlainLink
                                className="app-tip__button"
                                style={{
                                    whiteSpace: "nowrap",
                                    marginLeft: "auto",
                                    paddingLeft: 12,
                                    flexShrink: 0,
                                }}
                            />
                        </div>
                    ) : null}
                </Tips>
                <PersonalCampaigns />
            </Container>
        )
    } else {
        return (
            <Container padding="reduced">
                <PersonalCampaigns />
            </Container>
        )
    }
}

export default TopBanner
